import React from 'react'
import PageTitle from '../hooks/PageTitle'
import PageHeader from '../layouts/PageHeader'
import { ExperienceData } from '../data/ExperienceData'
import ExperienceLayout from '../layouts/ExperienceLayout'

const Experience = () => {
  return (
    <>
        <PageTitle title="Experience"/>
        <PageHeader headerTitle="Experience"/>

        {
          ExperienceData.map((item, index) => {
            return <ExperienceLayout key={index} designation={item.designation} institution={item.institution} duration={item.duration} address={item.address}  />
          }) 
        }

                    
                  
    </>
  )
}

export default Experience